import { render, staticRenderFns } from "./CheckoutPromotion.vue?vue&type=template&id=4fb5a9b5"
import script from "./CheckoutPromotion.vue?vue&type=script&lang=js"
export * from "./CheckoutPromotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports